module.exports = __webpack_public_path__ + "static/media/Artboard3.278613c6.png";